import { useScopedTranslation } from '../../application/localization/useScopedTranslation.ts';
import styles from './Footer.module.scss';
import { Links } from '../../application/constants/links.ts';
import { AppLink } from '../../components/uikit/buttons/AppLink.tsx';
import {
  appVersion,
  FeatureFlags,
} from '../../application/constants/env-variables.ts';
import clsx from 'clsx';

const LegalNotice = 'https://loewensteinmedical.com/en/legal-notice/';
const GTC = 'https://loewensteinmedical.com/en/gtcs/';
const PrivacyPolicy = 'https://loewensteinmedical.com/en/privacy-policy/';

const Footer = () => {
  const i18n = useScopedTranslation('Page.Footer');
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div>{i18n.t('main_text', { year: currentYear })}</div>
        <div className={styles.info}>
          <AppLink
            to={Links.Unauthorized.Contacts.route}
            className={styles.link}
          >
            {i18n.t('contacts')}
          </AppLink>
          <AppLink target={'_blank'} to={LegalNotice} className={styles.link}>
            {i18n.t('legal_notice')}
          </AppLink>
          <AppLink target={'_blank'} to={GTC} className={styles.link}>
            {i18n.t('gtc')}
          </AppLink>
          <AppLink target={'_blank'} to={PrivacyPolicy} className={styles.link}>
            {i18n.t('privacy_policy')}
          </AppLink>
        </div>
      </div>
      <div className={clsx(styles.link, styles.version)}>
        Version: {appVersion()}{' '}
        {FeatureFlags.isSupplierPortal() && '(Supplier Portal)'}
      </div>
    </footer>
  );
};

export default Footer;
